import axios from 'axios'

const client = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
})

export default {
    async submit({ name, email, answers, utm }) {
        const { data } = await client.post('unauthenticated/referral-leakage-audit', {
            name,
            email,
            answers,
            utm,
        })

        return data
    },

    async notifyStartFree({ email }) {
        const { data } = await client.post('unauthenticated/referral-leakage-audit/start-free', {
            email,
        })

        return data
    },
}
